import { render } from "./acledaPayment.vue?vue&type=template&id=0440e82d&scoped=true"
import script from "./acledaPayment.vue?vue&type=script&lang=js"
export * from "./acledaPayment.vue?vue&type=script&lang=js"

import "./acledaPayment.vue?vue&type=style&index=0&id=0440e82d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0440e82d"

export default script